const NAMESPACE = "paymentusDialog";

const KEYS = {
    cancelButtonLabel: "cancelButtonLabel",
    paymentAmountLabel: "paymentAmountLabel",
    billingEmailLabel: "billingEmailLabel",
    iFrameHelpText: "iFrameHelpText",
    paymentInputDialogHeader: "paymentInputDialogHeader",
    paymentProcessingDialogHeader: "paymentProcessingDialogHeader",
    paymentProcessingWaitMessage: "paymentProcessingWaitMessage",
    cancelPendingWaitMessage: "cancelPendingWaitMessage",
    cancelUnavailableWaitMessage: "cancelUnavailableWaitMessage",
    paymentFailedDialogHeader: "paymentFailedDialogHeader",
    paymentFailedErrorMessage1: "paymentFailedErrorMessage1",
    paymentFailedErrorMessage2_emphasized: "paymentFailedErrorMessage2_emphasized",
    paymentFailedDefaultReferenceNumber: "paymentFailedDefaultReferenceNumber",
    paymentFailedMessageReturnedLabel: "paymentFailedMessageReturnedLabel",
    paymentFailedReferenceNumberLabel: "paymentFailedReferenceNumberLabel",
    paymentFailedInstructions: "paymentFailedInstructions",
    paymentusFrameTitle: "paymentusFrameTitle"
};

const MESSAGES = {
    [KEYS.cancelButtonLabel]: {
        value: "Cancel",
        comment: "Label for the Cancel link button on the Checkout dialog"
    },
    [KEYS.paymentAmountLabel]: {
        value: "Amount to pay: ",
        comment: "Label for the payment amount"
    },
    [KEYS.billingEmailLabel]: {
        value: "Your receipt will be sent to: ",
        comment: "Label for the billing email"
    },
    [KEYS.iFrameHelpText]: {
        value:
            "If no payment inputs appear below, please cancel and try again." +
            " If the issue persists, contact your program administrator.",
        comment: "Help text for the Paymentus iFrame; i.e., what to do if that content is not displayed"
    },
    [KEYS.paymentInputDialogHeader]: {
        value: "Input Payment Details",
        comment: "Header for the Payment Details dialog when in input mode"
    },
    [KEYS.paymentProcessingDialogHeader]: {
        value: "Payment Details Submitted",
        comment: "Header for the Payment Details dialog when in processing mode"
    },
    [KEYS.paymentProcessingWaitMessage]: {
        value: "Processing payment, please wait...",
        comment: "Wait message displayed when a payment is being processed"
    },
    [KEYS.cancelPendingWaitMessage]: {
        value: "Cancel clicked, please wait...",
        comment: "Wait message displayed when cancel has been clicked"
    },
    [KEYS.cancelUnavailableWaitMessage]: {
        value: "Processing payment, cancel is unavailable...",
        comment: "Wait message displayed when a user cancel is rejected because a payment is already in process"
    },
    [KEYS.paymentFailedDialogHeader]: {
        value: "Payment Failed",
        comment: "Header for the dialog displayed when a payment fails"
    },
    [KEYS.paymentFailedErrorMessage1]: {
        value: "There was an error processing this payment.",
        comment: "First error message displayed when a payment fails, shown normally"
    },
    [KEYS.paymentFailedErrorMessage2_emphasized]: {
        value: "No funds have been transferred.",
        comment: "Second error message displayed when a payment fails, shown emphasized"
    },
    [KEYS.paymentFailedDefaultReferenceNumber]: {
        value: "n/a",
        comment: "Reference number placeholder to show when a payment fails, if none has been returned from Paymentus"
    },
    [KEYS.paymentFailedMessageReturnedLabel]: {
        value: "Message returned from payment processor:",
        comment: "Label for message returned by Paymentus explaining the failed payment"
    },
    [KEYS.paymentFailedReferenceNumberLabel]: {
        value: "Reference Number:",
        comment: "Label for the reference number returned by Paymentus for the failed payment"
    },
    [KEYS.paymentFailedInstructions]: {
        value:
            "You may make corrections and resubmit your payment." +
            " Please contact your program administrator if you require further assistance.",
        comment: "Instructions to the user displayed when a payment fails"
    },
    [KEYS.paymentusFrameTitle]: {
        value: "Payment Details",
        comment: "Title for the Paymentus iFrame"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
